import { getValues } from '@/utils';

import type { Schema } from '@/types/mercury-data-types/unifiedapi';

export type GslSection = {
  title: string;
  items: string[];
};

const toDisplayList = (value: unknown): string[] => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === 'string' || typeof item === 'number') {
          return String(item);
        }
        if (item && typeof item === 'object') {
          const record = item as { name?: string | null; id?: number };
          return record.name ?? (record.id != null ? String(record.id) : '');
        }
        return '';
      })
      .filter(Boolean);
  }

  if (typeof value === 'object') {
    return getValues(value as Record<string, string>).filter(Boolean);
  }

  return [];
};

export const gslSectionsFromClient = (
  client: Schema<'ClientResponse'> | undefined
): GslSection[] => {
  if (!client) return [];

  return [
    { title: 'Industry Sectors', items: toDisplayList(client.industries) },
    { title: 'Technologies', items: toDisplayList(client.technologies_used) },
    { title: 'Locations', items: toDisplayList(client.locations) },
    { title: 'Domains', items: toDisplayList(client.domains) },
    { title: 'URLs', items: toDisplayList(client.urls) },
    { title: 'IP ranges', items: toDisplayList(client.ip_ranges) },
    { title: 'Keywords', items: toDisplayList(client.keywords) },
  ];
};
